export default "__VITE_ASSET__15806396__"